module.exports = __webpack_public_path__ + "img/icon_3_28.d0311e08.png";